import { ArrowUpRight } from "lucide-react";
import { buildCalendlyUrl, trackScheduleConsultationClick } from "@/lib/calendly";

const VARIANTS = {
  // Dark button for light backgrounds
  dark: "bg-navy-900 text-warm-neutral hover:bg-navy-800",
  // Light button for dark backgrounds
  light: "bg-warm-neutral text-navy-900 hover:bg-white",
  // Warm accent button
  accent: "bg-warm-accent text-navy-900 hover:bg-warm-accent-soft",
};

const SIZES = {
  lg: "px-8 py-4 text-base md:text-lg",
  md: "px-6 py-3.5 text-sm md:text-base",
};

export const CalendlyButton = ({
  children,
  variant = "dark",
  size = "lg",
  testId,
  showIcon = true,
  className = "",
}) => {
  const handleClick = (e) => {
    // Capture the freshest query params at click time.
    e.currentTarget.href = buildCalendlyUrl();
    trackScheduleConsultationClick();
  };

  return (
    <a
      href={buildCalendlyUrl()}
      onClick={handleClick}
      data-testid={testId}
      data-conversion-event="schedule_consultation_click"
      className={`group inline-flex items-center justify-center gap-2.5 rounded-full font-body font-semibold tracking-wide transition-colors duration-300 ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
    >
      <span>{children}</span>
      {showIcon && (
        <ArrowUpRight
          className="h-[1.05em] w-[1.05em] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          aria-hidden="true"
        />
      )}
    </a>
  );
};

export default CalendlyButton;
